import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class CommentsService {

  constructor(private http:HttpClient) { }


  getcomments(user_id){
  //  return this.http.get(`http://localhost:8080/api/v1/admin/getcomments/${user_id}`).map(result=>result);
    return this.http.get(`http://www.api.playit.mobi/api/v1/admin/getcomments/${user_id}`).map(result=>result);

  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/comments.service.ts